/* eslint-disable */
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import Input from './Input';
import TechsicoHeaderLogo from '../images/techsico_header_logo_375.svg';
import FacebookIcon from './icons/FacebookIcon';
import TwitterIcon from './icons/TwitterIcon';
import LinkedInIcon from './icons/LinkedInIcon';
import InstagramIcon from './icons/InstagramIcon';
import useBreakpoints from '../hooks/useBreakPoint';

// TODO: will clean all the comments and logs after connecting with backend api
const Contact = () => {
  const { is3xl } = useBreakpoints();
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      message: '',
    },
    validationSchema: yup.object({
      name: yup.string().required('Required'),
      email: yup.string().email('Invalid email address').required('Required'),
      message: yup.string().required('Required'),
    }),
    onSubmit: (values, actions) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(process.env.REACT_APP_SITE_KEY, {
            action: 'submit',
          })
          .then(token => {
            // call a backend API to verify reCAPTCHA response
            // submit(token);            
            // axios.post(`https://www.google.com/recaptcha/api/siteverify?secret=6LeMnwErAAAAAP-CTLeAY7wmkM7OQgsZm5_K_F8u&response=${token}`)
            axios.put(`${process.env.REACT_APP_CORE_URL}api/website/${process.env.REACT_APP_SITE_KEY}/quote`,
              {...values, reCaptchaToken: token},
              {
                headers:{"content-type": "multipart/form-data"}
              }
            
            ).then(r => console.log(r),{
              withCredentials: true,
              })
          })
          // .then(() => {
          //   actions.resetForm();
          // });
      });
    },
  });
  // const [isLoading, setIsLoading] = React.useState(false);
  // const [response, setResponse] = React.useState(null);

  // const submit = token => {
  // fetch('http://localhost:????/endpointXXX', {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  //   body: JSON.stringify({
  //     name,
  //     email,
  //     message,
  //     'g-recaptcha-response': token,
  //   }),
  // })
  //   .then(res => res.json())
  //   .then(res => {
  //     setIsLoading(false);
  //     setResponse(res);
  //   });
  // };

  // const onSubmit = e => {
  //   e.preventDefault();

  //   window.grecaptcha.ready(() => {
  //     window.grecaptcha
  //       .execute(process.env.REACT_APP_SITE_KEY, {
  //         action: 'submit',
  //       })
  //       .then(() => {
  //         // call a backend API to verify reCAPTCHA response
  //         submit(token);
  //       });
  //   });
  // };

  return (
    <div
      id="contact"
      className="bg-techsicoGray-500 text-white py-19.5 px-5.25 md:px-20 md:pb-20 md:pt-22 md:grid md:grid-cols-2 md:grid-rows-4 lg:px-25 lg:py-20 lg:pb-0 lg:grid-cols-contact-lg lg:grid-rows-3 lg:gap-x-8 lg:gap-y-4 2xl:px-36.5 2xl:py-18 2xl:grid-rows-2 2xl:grid-cols-contact-2xl 2xl:pb-14 3xl:px-44.5"
    >
      {/* section 1 */}
      <div className="mb-6 md:row-span-1 md:col-span-2 lg:col-span-1">
        <img
          className="w-36 h-8 lg:h-12 lg:w-54 3xl:w-72 3xl:h-16"
          src={TechsicoHeaderLogo}
          alt="Techsico Logo"
        />
        <h2 className="text-5xl font-montserrat leading-1.15em font-bold lg:text-6.3xl 3xl:text-7.7xl">
          Enterprise
        </h2>
      </div>
      {/* section 2 */}
      <div className="md:col-span-1 md:row-span-3 lg:row-start-2 lg:col-start-1">
        <div className="inline-block align-top w-37 h-19.5 mb-6 mr-8 lg:mr-12 lg:w-46 lg:h-auto lg:mb-8 2xl:mr-16 3xl:w-56 3xl:mr-24">
          <h3 className="text-xl leading-6 font-bold font-rubik mb-4 md:text-2xl 3xl:text-2.5xl">
            Address
          </h3>
          <p className="leading-4.75 text-techsicoGray-200 font-montserrat font-light lg:text-xl 3xl:text-2xl">
            {/* Replicates svg */}
            {`910 S. Hudson Ave.\nTulsa, OK 74112`}
          </p>
        </div>
        <div className="inline-block align-top mr-8 mb-6 lg:mr-12 lg:w-auto 2xl:mr-16 3xl:mr-24">
          <h3 className="text-xl leading-6 font-bold font-rubik mb-4 md:text-2xl 3xl:text-2.5xl">
            Phone
          </h3>
          <a
            href="tel:+1-918-585-2347"
            className="leading-4.75 text-techsicoGray-200 font-montserrat font-light lg:text-xl 3xl:text-2xl hover:underline"
          >
            918-585-2347
          </a>
        </div>
        <div className="inline-block align-top mb-6 mr-8">
          <h3 className="text-xl font-bold font-rubik mb-3 md:mb-4 md:text-2xl 3xl:text-2.5xl">
            Follow us
          </h3>
          <div className="flex justify-between align-center w-39.5 3xl:w-58">
            <a
              href="https://www.facebook.com/TECHSICO"
              target="_blank"
              rel="noreferrer"
              title="Click to navigate to Techsico Facebook page"
            >
              {is3xl ? (
                <FacebookIcon />
              ) : (
                <FacebookIcon width="32" height="32" />
              )}
            </a>
            <a
              href="https://twitter.com/TECHSICO"
              target="_blank"
              rel="noreferrer"
              title="Click to navigate to Techsico Twitter page"
            >
              {is3xl ? <TwitterIcon /> : <TwitterIcon width="32" height="32" />}
            </a>
            <a
              href="https://www.linkedin.com/company/techsico-inc/"
              target="_blank"
              rel="noreferrer"
              title="Click to navigate to Techsico LinkedIn page"
            >
              {is3xl ? (
                <LinkedInIcon />
              ) : (
                <LinkedInIcon width="32" height="32" />
              )}
            </a>
            <a
              href="https://www.instagram.com/techsicoinc/"
              target="_blank"
              rel="noreferrer"
              title="Click to navigate to Techsico Instagram page"
            >
              {is3xl ? (
                <InstagramIcon />
              ) : (
                <InstagramIcon width="32" height="32" />
              )}
            </a>
          </div>
        </div>
      </div>
      {/* section 3 */}
      {/* <form
        onSubmit={formik.handleSubmit}
        className="md:col-span-1 md:row-span-3"
      >
        <h3 className="text-2xl font-bold font-rubik mb-4 lg:text-2.5xl">
          Contact us
        </h3>
        <div className="mb-7">
          <Input
            id="name"
            placeholder="Name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.name}
            touched={formik.touched.name}
            error={formik.errors.name}
          />
        </div>
        <div className="mb-7">
          <Input
            id="email"
            placeholder="Email"
            type="email"
            onChange={formik.handleChange}
            value={formik.values.email}
            touched={formik.touched.email}
            error={formik.errors.email}
          />
        </div>
        <div className="mb-7">
          <textarea
            id="message"
            name="message"
            placeholder="Message"
            cols="30"
            rows="10"
            value={formik.values.message}
            onChange={formik.handleChange}
            className="bg-transparent placeholder-white text-white border-white border-4 rounded-2xl text-sm px-4 py-3 w-full font-montserrat font-bold leading-1.55em h-32 lg:text-base lg:h-44 focus:outline-none focus:border-enterpriseOrange-500"
          />
          {formik.touched.message && formik.errors.message ? (
            <div className="absolute font-montserrat font-bold text-sm text-enterpriseOrange-500 px-5">
              {formik.errors.message}
            </div>
          ) : null}
        </div>
        <div className="flex flex-row justify-end">
          <input
            type="submit"
            value="Submit"
            className="inline-block uppercase border-white bg-transparent border-2 rounded-lg text-white py-2 px-4 font-bold font-rubik leading-5 hover:bg-enterpriseOrange-500 focus:outline-none focus:border-enterpriseOrange-500"
          />
        </div>
      </form> */}
    </div>
  );
};

export default Contact;
